import { Injectable, inject } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import isString from 'lodash-es/isString';
import isArray from 'lodash-es/isArray';
import isObject from 'lodash-es/isObject';
import { errorCodeExtractor, errorMessageExtractor } from './errors.utils';

@Injectable()
export class ErrorsInterceptor implements HttpInterceptor {

  #errCodeExtractor = inject(errorCodeExtractor);
  #errMessageExtractor = inject(errorMessageExtractor);

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next
      .handle(req)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          let errType: 'string' | 'object' | 'array';

          if (isString(err.error)) {
            errType = 'string';
          }

          if (isObject(err.error)) {
            errType = 'object';
          }

          if (isArray(err.error)) {
            errType = 'array';
          }

          return throwError(() => ({
            code: this.#errCodeExtractor(err),
            message: this.#errMessageExtractor(err),
            status: err.status,
            meta: err.error?.error?.meta,
            originalError: err,
            errType
          }));
        })
      );
  }
}
